var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDcl201(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 505 510.3",
    enableBackground: "new 0 0 505 510.3",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 372.7,
    cy: 396.5,
    r: 7.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 144.6,
    cy: 396.5,
    r: 7.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2A2D30",
    d: "M505,257.8c0,139.4-113,252.5-252.5,252.5S0,397.2,0,257.8l70.4-70.4l70.4,70.4 c0,61.7,50,111.7,111.7,111.7c61.7,0,111.7-50,111.7-111.7H505z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M18.3,251.9c-0.8,0-1.6-0.3-2.2-0.9c-1.2-1.2-1.2-3.2,0-4.5l54.3-54.3l53.9,53.9c1.2,1.2,1.2,3.2,0,4.5 s-3.2,1.2-4.5,0l-49.4-49.4L20.6,251C19.9,251.6,19.1,251.9,18.3,251.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M18.3,278.2c-0.8,0-1.6-0.3-2.2-0.9c-1.2-1.2-1.2-3.2,0-4.5l54.3-54.3l53.9,53.9c1.2,1.2,1.2,3.2,0,4.5 c-1.2,1.2-3.2,1.2-4.5,0l-49.4-49.4l-49.8,49.8C19.9,277.9,19.1,278.2,18.3,278.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M18.3,304.4c-0.8,0-1.6-0.3-2.2-0.9c-1.2-1.2-1.2-3.2,0-4.5l54.3-54.3l53.9,53.9c1.2,1.2,1.2,3.2,0,4.5 c-1.2,1.2-3.2,1.2-4.5,0l-49.4-49.4l-49.8,49.8C19.9,304.1,19.1,304.4,18.3,304.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M369.5,252.4c-2.8-62.1-54.3-111.7-117-111.7c-60.4,0-110.2,45.9-116.5,104.7l-65.6-65.6L5.8,244.3 c3.3-60.9,28.5-117.7,72-161.2c46.7-46.7,108.7-72.4,174.7-72.4c66,0,128,25.7,174.7,72.4c45.4,45.4,70.9,105.3,72.3,169.3H369.5 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2A2D30",
    d: "M252.5,16.2c32.6,0,64.3,6.4,94,19c28.8,12.2,54.6,29.6,76.8,51.8c22.2,22.2,39.6,48,51.8,76.8 c11.2,26.5,17.5,54.4,18.7,83.2H374.6c-5.5-62.5-58.2-111.7-122.1-111.7c-59.4,0-109.1,42.5-120.2,98.7l-54.2-54.2l-7.7-7.7 l-7.7,7.7L12.4,230c2.6-22.8,8.4-45,17.4-66.2C42,135,59.4,109.1,81.6,86.9c22.2-22.2,48-39.6,76.8-51.8 C188.2,22.5,219.9,16.2,252.5,16.2 M252.5,5.3C113,5.3,0,118.3,0,257.8l70.4-70.4l70.4,70.4c0-61.7,50-111.7,111.7-111.7 c61.7,0,111.7,50,111.7,111.7H505C505,118.3,391.9,5.3,252.5,5.3L252.5,5.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2A2D30",
    d: "M484.5,234H383.1c-1.8,0-3.2-1.4-3.2-3.2s1.4-3.2,3.2-3.2h101.4c1.8,0,3.2,1.4,3.2,3.2 S486.3,234,484.5,234z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2A2D30",
    d: "M480,216.9H378.6c-1.8,0-3.2-1.4-3.2-3.2s1.4-3.2,3.2-3.2H480c1.8,0,3.2,1.4,3.2,3.2 S481.7,216.9,480,216.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2A2D30",
    d: "M473.7,199.8H372.2c-1.8,0-3.2-1.4-3.2-3.2s1.4-3.2,3.2-3.2h101.4c1.8,0,3.2,1.4,3.2,3.2 S475.4,199.8,473.7,199.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2A2D30",
    d: "M126.3,162.3l-16-14.4c-7.8-7-8.5-13.7-2.6-20.3l0.4-0.4c6-6.6,12.7-6.5,20.5,0.5l16,14.4 c7.6,6.9,8.8,13.4,2.7,20.2l-0.6,0.7C140.6,169.6,133.9,169.1,126.3,162.3z M139.4,148.9l-17.3-15.6c-3.8-3.4-6.2-3.6-8.6-1 c-2.4,2.6-2,5,1.8,8.5l17.3,15.6c3.7,3.4,6.3,3.7,8.7,1.1C143.8,154.8,143.2,152.3,139.4,148.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2A2D30",
    d: "M135.9,102.6l7.3-4.7l26,20.3l0.2-0.1l-16.9-26.2l6.4-4.2l27.4,42.4l-7.3,4.7l-26-20.4l-0.2,0.1l17,26.2 l-6.4,4.2L135.9,102.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2A2D30",
    d: "M180.5,77.7l22.4-7.5l2.5,7.6l-14.5,4.9l4.1,12.1l12.6-4.2l2.5,7.6l-12.6,4.2l4.3,12.9l14.5-4.9l2.6,7.7 l-22.4,7.5L180.5,77.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2A2D30",
    d: "M253.5,72.2l-8.9-0.3l0.2-8.1l26.3,0.7l-0.2,8.1l-8.8-0.2l-1.2,42.4l-8.6-0.2L253.5,72.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2A2D30",
    d: "M291.2,67.7l22.8,6l-2,7.8l-14.8-3.9L294,89.9l12.8,3.4l-2,7.8l-12.8-3.4l-3.5,13.1l14.8,3.9l-2.1,7.8 l-22.8-6L291.2,67.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2A2D30",
    d: "M329.7,124.2l-8.5-4.6l-6.8,8.9l-7.1-3.8l31.8-40.4l10.8,5.9l-16.4,48.7l-7.6-4.1L329.7,124.2z  M341.1,92.5l-15.3,20.8l6.7,3.6l8.9-24.3L341.1,92.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2A2D30",
    d: "M375.7,107.1l9.9,9.9L364,146.8l0.1,0.1l29.9-21.5l9.9,9.9L368.1,171l-6-6.1l30.9-30.7l-0.1-0.1 L357,159.8l-6.4-6.4l25.9-35.7l-0.1-0.1l-30.8,30.8l-5.7-5.7L375.7,107.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M160.1,371.1l15.2,10c11.3,7.4,13.3,16.6,5.9,28l-9.9,15c-8.4,12.7-17,13.2-28,5.9l-15.4-10.1 L160.1,371.1z M148.4,422.1c5.9,3.9,9.7,3,14.1-3.5l10.2-15.5c4.2-6.3,3.2-10.2-2.5-14l-6.7-4.4l-21.8,33L148.4,422.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M235.2,442.6c-2.9,15.3-10.5,18.9-21.9,16.8l-1.1-0.2c-12.4-2.3-17.3-10.6-14.8-23.8l3.5-18.9 c2.5-13.6,10.4-19.3,22.7-17l0.7,0.1c11.9,2.2,17,10.3,14.4,23.9l-0.4,2.2l-9.6-1.8l0.6-3c1.4-7.7-1-11.3-7-12.4 c-6.1-1.1-9.6,1.4-11,9l-3.8,20.5c-1.4,7.5,0.9,11.5,7,12.6c6,1.1,9.7-1.6,11.1-9.1l0.5-2.7l9.6,1.8L235.2,442.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M278.6,448.8l26.8-5.7l2,9.5l-36.9,7.8l-12.1-57.2l10.1-2.1L278.6,448.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M329.8,433.3l6.9-22.7c3-10,2.8-12.8-0.2-17.3c-3.4-5.1-6.1-5.8-11.4-2.4c-5.5,3.6-6.2,6.9-3,11.8 l0.7,1.1l-8.3,5.5l-0.4-0.6c-6.3-9.5-4.9-17.7,6-24.9l0.6-0.4c11.1-7.4,18.3-5,23.9,3.6c5.5,8.2,4.6,15,1,26.5l-3.4,11l0.1,0.1 l19.6-13l5.2,7.8l-32.3,21.3L329.8,433.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M82.3,325.9l2.1,5.3l-1.8,0.7l-1.4-3.5l-2.9,1.2l1.2,3l-1.8,0.7l-1.2-3l-3.1,1.2l1.4,3.5l-1.8,0.7 l-2.1-5.3L82.3,325.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M76.6,337.5l0.2-0.1l0.8,1.8l-0.4,0.2c-0.8,0.4-1,0.7-0.6,1.4c0.3,0.7,0.7,0.8,1.3,0.5 c0.7-0.3,0.7-0.6,0.7-1.9c0-1.7,0.1-2.7,1.6-3.4c1.6-0.7,2.8-0.2,3.6,1.5l0,0c0.8,1.8,0.4,3-1.5,3.9l-0.2,0.1l-0.8-1.8l0.3-0.1 c0.8-0.4,1-0.8,0.7-1.4c-0.3-0.6-0.6-0.7-1.2-0.5c-0.7,0.3-0.7,0.6-0.7,1.9c0,1.7,0,2.7-1.7,3.5c-1.7,0.8-2.8,0.3-3.7-1.4 l-0.1-0.2C74.3,339.6,74.8,338.3,76.6,337.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M85.9,346.1l-4.1,2.1c-0.7,0.3-0.7,0.8-0.4,1.5c0.1,0.2,0.2,0.4,0.3,0.6l-1.6,0.8 c-0.2-0.3-0.2-0.4-0.4-0.7c-1-2-0.6-3.1,1-3.9l4.3-2.2l-0.6-1.2l1.5-0.8l0.6,1.2l2.1-1.1l0.9,1.8l-2.1,1.1l0.8,1.6l-1.5,0.8 L85.9,346.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M85.2,354.6l-2.3,1.3l-1.2-2.1l2.3-1.3L85.2,354.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M88.3,361.9c5.6,0.5,6.9,0.5,8.6-0.6c1-0.6,1.2-1.1,0.7-1.8c-0.4-0.7-1-0.7-1.9-0.1l-0.7,0.4l-1.1-1.6 l0.5-0.3c2-1.3,3.5-1.2,4.7,0.7l0.1,0.1c1.1,1.8,0.6,3.2-1.2,4.3c-2.3,1.5-4.8,1.3-8,0.9l0,0l2,3.1l-1.6,1l-3.5-5.3L88.3,361.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M95.1,368.8l4.3-3.1c2.1-1.5,3.7-1.3,5,0.4l0.1,0.1c1.3,1.8,0.9,3.4-1.2,4.9l-4.3,3.1 c-2,1.5-3.6,1.4-5-0.4l-0.1-0.2C92.6,371.8,93.1,370.3,95.1,368.8z M97.6,372.6l4.6-3.3c1-0.7,1.2-1.3,0.7-2 c-0.5-0.7-1.1-0.7-2.1,0l-4.6,3.3c-1,0.7-1.2,1.3-0.7,2C96,373.3,96.6,373.3,97.6,372.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M103,381.7l-1.6,1.2l-3.3-4.1l1.6-1.2l1,1.2l6.4-5.1l-1.3-0.9l1.6-1.3l1.6,1.2l1,1.3l-8.1,6.4L103,381.7z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M105.8,382.9l0.2-0.1l1.4,1.6l-0.3,0.2c-0.9,0.8-1.1,1.4-0.5,2c0.6,0.6,1.2,0.6,2.1-0.2l2.5-2.2l0,0 c-1.2,0.9-2.2,0.8-3.1-0.2c-1-1.2-0.8-2.4,0.8-3.8l1.1-0.9c1.7-1.5,3.3-1.5,4.7,0.2l0.1,0.2c1.4,1.6,1.2,3.2-0.7,4.9l-3.9,3.5 c-1.9,1.7-3.5,1.8-5,0.1l-0.1-0.2C103.7,386.1,104,384.5,105.8,382.9z M112.3,383.2l0.7-0.6c0.9-0.8,1.1-1.4,0.5-2.1 c-0.6-0.6-1.2-0.6-2.1,0.2l-0.7,0.7c-0.8,0.7-1,1.3-0.4,1.9C110.8,384,111.5,383.9,112.3,383.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M388.9,383.7l-1.5,1.8l1.8,2.1l-1.3,1.5l-8-9.7l2-2.3l10.8,6.4l-1.4,1.6L388.9,383.7z M381.9,379.4 l4.2,4.7l1.2-1.4L381.9,379.4L381.9,379.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M392.6,375.3l5.5,1.2l-1.3,1.7l-4.7-1.1l0,0l3.4,2.7l-1.2,1.6l-9.7-7.5l1.2-1.6l5.4,4.1l0,0l-1.6-3.8 l1.3-1.7L392.6,375.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M392.4,368.9l1.1-1.6l0.3,0.2c0.5,0.3,0.9,0.6,1.6,1.1l0,0c-1.4-1.1-1.6-2.1-0.9-3.1c0.7-1,1.7-1,3-0.1 l1.4,1l-1.1,1.6l-0.9-0.6c-0.8-0.5-1.2-0.5-1.5-0.1c-0.4,0.5-0.2,1.1,0.9,1.9l4.6,3.3l-1.1,1.6L392.4,368.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M402.3,365.2l-2.5-1.6c-1.9-1.2-2.3-2.6-1.2-4.4l0-0.1c1.1-1.7,2.6-1.9,4.4-0.8l2.5,1.6 c1.9,1.2,2.3,2.6,1.2,4.3l-0.1,0.2C405.6,366.1,404.1,366.3,402.3,365.2z M404.8,361.9l-3.1-2c-0.8-0.5-1.3-0.4-1.7,0.2 c-0.4,0.6-0.3,1.1,0.5,1.6l3.1,2c0.8,0.5,1.3,0.4,1.7-0.2C405.7,362.9,405.6,362.4,404.8,361.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M402,354.2l1-1.7l0.4,0.2c0.5,0.3,0.9,0.5,1.5,0.9l0,0c-1.4-1-1.7-1.9-1-3.1c0.6-1.1,1.6-1.3,3.1-0.5 l6,3.4l-1,1.7l-5.4-3c-0.8-0.4-1.3-0.4-1.6,0.2c-0.4,0.7-0.1,1.3,0.8,1.8l5.2,2.9l-1,1.7L402,354.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M415.7,351l0.1-0.1c0.4-0.9,0.2-1.1-0.5-1.5l-0.3-0.1l-0.5,1.1l-2.4-1.2l1.1-2.1l2.6,1.3 c1.5,0.8,1.8,1.8,1.1,3.3L415.7,351z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M417.8,334.9l-4.9-1.9c-2.4-0.9-3.1-2.4-2.3-4.4l0.1-0.1c0.8-2,2.3-2.6,4.7-1.6l4.9,1.9 c2.3,0.9,3.2,2.3,2.3,4.4l-0.1,0.2C421.7,335.4,420.1,335.8,417.8,334.9z M419.7,330.7l-5.3-2.1c-1.2-0.5-1.7-0.3-2.1,0.5 c-0.3,0.8,0,1.3,1.1,1.8l5.3,2.1c1.1,0.5,1.8,0.3,2.1-0.5C421.2,331.7,420.8,331.2,419.7,330.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M413.1,322.7l0.6-1.9l3.5,1.2c0.5,0.2,1,0.4,1.6,0.6l0,0c-1.5-0.7-2-1.6-1.6-2.8c0.4-1.2,1.4-1.6,3-1 l6.5,2.2l-0.6,1.9l-5.9-2c-0.9-0.3-1.4-0.2-1.6,0.4c-0.3,0.8,0.1,1.3,1.1,1.6l5.6,1.9l-0.6,1.9L413.1,322.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M416.6,312.2l2.1,0.6l-0.6,1.9l-2.1-0.6L416.6,312.2z M419.5,313.1l8.7,2.5l-0.6,1.9L419,315L419.5,313.1 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M426.2,311.6l-2.9-0.7c-2.2-0.5-3-1.8-2.5-3.8l0-0.1c0.5-2,1.8-2.6,4-2.1l2.9,0.7c2.1,0.5,3,1.7,2.5,3.7 l0,0.2C429.7,311.5,428.3,312.2,426.2,311.6z M427.5,307.7l-3.5-0.9c-0.9-0.2-1.4,0-1.5,0.7c-0.2,0.7,0.1,1.1,1,1.4l3.5,0.9 c0.9,0.2,1.3-0.1,1.5-0.7C428.7,308.4,428.5,307.9,427.5,307.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M485,285.4c-0.1,0-0.2,0-0.3,0l-25.1-2.6c-1.7-0.2-3-1.7-2.8-3.5c0.2-1.7,1.7-3,3.5-2.8l25.1,2.6 c1.7,0.2,3,1.7,2.8,3.5C488,284.2,486.6,285.4,485,285.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M481.2,309.6c-0.2,0-0.4,0-0.7-0.1l-24.7-5.2c-1.7-0.4-2.8-2-2.4-3.8c0.4-1.7,2-2.8,3.8-2.4l24.7,5.2 c1.7,0.4,2.8,2,2.4,3.8C483.9,308.5,482.6,309.6,481.2,309.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M474.8,333.2c-0.3,0-0.7,0-1-0.2l-24-7.8c-1.7-0.5-2.6-2.3-2-4c0.5-1.7,2.3-2.6,4-2l24,7.8 c1.7,0.5,2.6,2.3,2,4C477.4,332.3,476.2,333.2,474.8,333.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M466.1,356c-0.4,0-0.9-0.1-1.3-0.3l-23-10.3c-1.6-0.7-2.3-2.6-1.6-4.2s2.6-2.3,4.2-1.6l23,10.3 c1.6,0.7,2.3,2.6,1.6,4.2C468.4,355.3,467.3,356,466.1,356z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M454.9,377.8c-0.5,0-1.1-0.1-1.6-0.4l-21.8-12.6c-1.5-0.9-2-2.8-1.2-4.3c0.9-1.5,2.8-2,4.3-1.2l21.8,12.6 c1.5,0.9,2,2.8,1.2,4.3C457.1,377.3,456,377.8,454.9,377.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M441.6,398.4c-0.6,0-1.3-0.2-1.9-0.6l-20.4-14.8c-1.4-1-1.7-3-0.7-4.4s3-1.7,4.4-0.7l20.4,14.8 c1.4,1,1.7,3,0.7,4.4C443.6,397.9,442.6,398.4,441.6,398.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M426.2,417.4c-0.8,0-1.5-0.3-2.1-0.8l-18.7-16.9c-1.3-1.2-1.4-3.2-0.2-4.5c1.2-1.3,3.2-1.4,4.5-0.2 l18.7,16.9c1.3,1.2,1.4,3.2,0.2,4.5C427.9,417,427.1,417.4,426.2,417.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M408.9,434.7c-0.9,0-1.7-0.4-2.4-1l-16.9-18.7c-1.2-1.3-1.1-3.3,0.2-4.5c1.3-1.2,3.3-1.1,4.5,0.2 l16.9,18.7c1.2,1.3,1.1,3.3-0.2,4.5C410.4,434.4,409.7,434.7,408.9,434.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M389.9,450.1c-1,0-1.9-0.5-2.6-1.3l-14.8-20.4c-1-1.4-0.7-3.4,0.7-4.4s3.4-0.7,4.4,0.7l14.8,20.4 c1,1.4,0.7,3.4-0.7,4.4C391.2,449.9,390.5,450.1,389.9,450.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#2A2D30",
    cx: 63.4,
    cy: 143.9,
    r: 8
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#2A2D30",
    cx: 81.1,
    cy: 118.7,
    r: 8
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#2A2D30",
    cx: 102.1,
    cy: 96.2,
    r: 8
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#2A2D30",
    cx: 126.1,
    cy: 76.8,
    r: 8
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#2A2D30",
    cx: 152.5,
    cy: 61,
    r: 8
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#2A2D30",
    cx: 180.9,
    cy: 49,
    r: 8
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#2A2D30",
    cx: 210.6,
    cy: 41,
    r: 8
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#2A2D30",
    cx: 241.2,
    cy: 37.3,
    r: 8
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 118.4,
    cy: 392.5,
    r: 2.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 73.8,
    cy: 319.8,
    r: 2.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 376.7,
    cy: 392.5,
    r: 2.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 428.5,
    cy: 295.5,
    r: 2.9
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#2A2D30",
    strokeWidth: 5.4764,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 323.8,216.3 266.5,244 237.9,257.8 223.9,251.8 166.6,227.2 252.5,185.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#2A2D30",
    strokeWidth: 5.4764,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 323.8,216.3 323.8,268.7 310.7,275 292.8,266.8 295,265.6 295,240.5 276.9,249.1 276.9,259.5 266.4,254.6 249.9,261.5 249.9,285.5  269.8,294.7 237.9,310.2 237.9,257.8 266.5,244  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#2A2D30",
    strokeWidth: 5.4764,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 237.9,257.8 237.9,310.1 211.8,298.9 211.8,278.6 199.7,273.7 187.7,268.7 187.7,288.6 166.6,279.5 166.6,227.2 223.9,251.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#2A2D30",
    strokeWidth: 5.4764,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 211.8,278.6 211.8,298.9 199.7,293.8 199.7,273.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#2A2D30",
    strokeWidth: 5.4764,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 199.7,273.7 199.7,293.8 187.7,288.6 187.7,268.7  "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#2A2D30",
    strokeWidth: 5.4764,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 199.7,
    y1: 293.8,
    x2: 199.7,
    y2: 293.8
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#2A2D30",
    strokeWidth: 5.4764,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 295,240.4 295,265.6 292.8,266.8 277,259.5 277,249.1  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#2A2D30",
    strokeWidth: 5.4764,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 338.4,287.9 321.9,294.8 295.2,282.5 278.2,274.6 276.9,274 249.9,261.5 266.4,254.6 276.9,259.5 292.8,266.8 310.7,275  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#2A2D30",
    strokeWidth: 5.4764,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 321.9,294.8 321.9,318.8 316.6,316.3 306.4,311.6 306.4,311.6 269.8,294.7 249.9,285.5 249.9,261.5 276.9,274 278.2,274.6  295.2,282.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#2A2D30",
    strokeWidth: 5.4764,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 338.4,287.9 338.4,311.8 321.9,318.8 321.9,294.8  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#2A2D30",
    strokeWidth: 5.4764,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 311.1,329.9 306.4,327.3 306.4,311.6  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#2A2D30",
    strokeWidth: 5.4764,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 320.4,327.3 316.6,324.9 316.6,316.3  "
  })), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#2A2D30",
    strokeWidth: 5.4764,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 306.4,
    y1: 327.3,
    x2: 299.9,
    y2: 323
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#2A2D30",
    strokeWidth: 5.4764,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 316.6,
    y1: 324.9,
    x2: 311.7,
    y2: 321.8
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDcl201);
export default __webpack_public_path__ + "static/media/dcl2-01.f3693dacd184817b78578b7649a594d0.svg";
export { ForwardRef as ReactComponent };